import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useNavigate } from 'react-router-dom';

const ForbiddenPage = () => {

  const navigate = useNavigate();

  useEffect(() => {
    const userId = localStorage.getItem('loggedInUserId');
    if (!userId) {
      navigate('/login');
    }
  }, [navigate]);

  // Disable right-click and common inspect shortcuts
  useEffect(() => {
    const handleContextMenu = (e) => e.preventDefault();
  
    const handleKeyDown = (e) => {
      if (e.key === 'F12') {
        e.preventDefault();
        return false;
      }
      if (
        (e.ctrlKey || e.metaKey) && 
        (e.shiftKey && ['I', 'J', 'C', 'K'].includes(e.key.toUpperCase()))
      ) {
        e.preventDefault();
        return false;
      }
      if (
        (e.ctrlKey || e.metaKey) &&
        ['U', 'S', 'P'].includes(e.key.toUpperCase())
      ) {
        e.preventDefault();
        return false;
      }
    };
  
    window.addEventListener('contextmenu', handleContextMenu);
    window.addEventListener('keydown', handleKeyDown);
  
    return () => {
      window.removeEventListener('contextmenu', handleContextMenu);
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);


  return (
    <>
    <Header />
    <div className="d-flex justify-content-center align-items-center min-vh-100">
      <div className="text-center">
        <h1 className="display-1 text-danger">403</h1>
        <h2 className="h3">Access Denied!</h2>
        <p className="lead">You do not have permission to view Lectures.</p>
        <p className="lead">Please contact Admin!</p>
        <Link to="/" className="btn btn-primary">Go to Home</Link>
      </div>
    </div>
    <Footer />
    </>
  );
};

export default ForbiddenPage;
